import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-watchdog',
  templateUrl: 'watchdog.component.html',
  styleUrls: ['watchdog.component.css']
})
export class WatchdogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
